var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowBottomOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88.002,
    height: 104.213,
    viewBox: "0 0 22 26.053",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14.474h6.368V0h9.264v14.474H22l-11 11.58-11-11.58z",
    fill: "#32d7a5",
    fillRule: "evenodd",
    "data-name": "\\u5408\\u4F53 10"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBottomOn);
export default __webpack_public_path__ + "static/media/arrowBottomOn.6505025f61d4c612.svg";
export { ForwardRef as ReactComponent };